
import { Component, Input, ViewEncapsulation,
    OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'jui-select',
    template: `
        <div class="jui-select-wrap">
            <jui-dropdown trigger="click" [dataSource]="_dataSrc"
                [width]="width || minWidth"
                (selectChange)="valueSelected($event)"
                (getDropdownVisible)="getDropdownVisible($event)"
                [maxHeight]="maxHeight">
                <button jui-btn 
                    [disabled]="!enabled"
                    [class.width.px]="width"
                    [class.minWidth.px]="minWidth"
                    [class.height.px]="height"
                    btnEffect="useEffect?'spread':''">
                    <span class="txt">
                        {{_displayName || defaultName || '--'}}
                    </span>
                    <i class="iconfont" [ngClass]="iconCls" 
                        (click)="iconClicked($event)"></i>
                </button>
            </jui-dropdown>
        </div>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      jui-select .jui-select-wrap {
        display: inline-block; }
        jui-select .jui-select-wrap .jui-btn {
          border: 1px #bcc1cc solid;
          color: #5e6166;
          text-align: left;
          padding-right: 10px;
          padding-left: 10px; }
          jui-select .jui-select-wrap .jui-btn:hover {
            color: #108ee9; }
          jui-select .jui-select-wrap .jui-btn:disabled {
            color: #5e6166; }
          jui-select .jui-select-wrap .jui-btn .iconfont {
            top: 50%;
            right: 8px;
            position: static; }
          jui-select .jui-select-wrap .jui-btn:before {
            content: " ";
            display: table; }
        jui-select .jui-select-wrap .ui-dropdown {
          overflow-y: auto;
          border: 1px #eee solid;
          box-shadow: -2px 2px 6px #eee; }
        jui-select .jui-select-wrap .dropdown-menu {
          max-height: 300px;
          overflow: hidden;
          padding: 0; }
          jui-select .jui-select-wrap .dropdown-menu .dropdown-item {
            padding: 5px 0;
            text-align: center; }
    `],
    encapsulation: ViewEncapsulation.None
})
export class SelectComponent implements OnInit {
    public key = 'dd' + ('' + Math.random()).substr(2);
    public selectedItem: any;

    @Input()
    public srcKey: string; // 如果设置了，说明_dataSrc里存的是一个map
    @Input()
    public enabled = true;
    @Input()
    public maxHeight: number | string = 200;
    @Input()
    public useEffect = true;
    @Input()
    public iconCls = 'icon-jui-down2';

    @Input()
    public set dataSrc(data) {
        if (!data) {
            return;
        }
        this._dataSrc = this.simplyFormatDataSrc(data);
    };
    @Input()
    public defaultName: string;
    @Input()
    public displayName: string; // 用于永远显示的名字
    public _displayName: string;
    @Input()
    public height: number = 30;
    @Input()
    public width: number;
    @Input()
    public minWidth: number;
    @Input()
    public maxWordCnt: number;
    @Input('selected')
    public set selected(value: string | number) {
        this._selected = value;
        // 修改displayName
        if ( this._dataSrc ) {
            let len = this._dataSrc.length;
            for ( let i = 0; i < len; i ++ ) {
                let item = this._dataSrc[i];
                if (!item) {
                    continue;
                }
                if ( value === item.value ) {
                    if (!this.displayName) {
                        this._displayName = this.formatName(item.name);
                    }
                    this.selectedItem = item;
                    return;
                }
            }
        }
    }
    @Output() // 这个别用
    public selectedChange: EventEmitter<any> = new EventEmitter(); // 跟上面对应，给双向绑定用

    @Output()
    public selectChange: EventEmitter<any> = new EventEmitter(); // 用于给外部做事件绑定

    public _dataSrc: any[];
    public _selected: string | number;

    constructor() {
        // pass
    }
    public ngOnInit() {
        this._displayName = this.displayName;
        if (this._dataSrc) {
            if ( this._selected ) {
                let len = this._dataSrc.length;
                for ( let i = 0; i < len; i ++ ) {
                    let item = this._dataSrc[i];
                    if ( item.value === this._selected ) {
                        if (!this.displayName && !this.defaultName) {
                            this._displayName = this.formatName(item.name);
                        }
                        this.selectedItem = item;
                        break;
                    }
                }
            } else {
                if ( this._dataSrc.length > 0 ) {
                    if (!this.displayName && !this.defaultName) {
                        this._displayName = this.formatName(this._dataSrc[0].name) || '-选择-';
                    }
                    this._selected = this._dataSrc[0].value || '';
                }
            }
        }
    }

    public valueSelected(item) {
        if (!this.displayName) {
            this._displayName = this.formatName(item.name);
        }
        if (this.selectedItem !== item) {
            this.selectedItem = item;
            this.selectChange.emit(item);
            this.selectedChange.emit(item.value);
        }
    }
    public getDropdownVisible(value) {
        // 注意！删掉此方法，dropdown组件的下拉框将不会消失。
        // 由于pager组件引用了此组件，且pager组件采用了ChangeDetection策略，接管了ng的dom更新，
        // 所以要手动执行一下dropdown组件里的方法，通过zone的暴力检测来触发dropdown组件里的dom更新。
    }
    public iconClicked(event) {
        // if (!this.enabled) {
        //     event.stopPropagation();
        // }
    }
    private simplyFormatDataSrc(data) {
        let key = this.srcKey;
        if (!data) {
            return null;
        }
        return data.map( (item) => {
            if (!item) {
                return;
            }
            let value = item;
            let name = item.name || item.label || item[key] || item;
            if (key) {
                value = item[key];
            } else {
                if (item.id !== undefined) {
                    value = item.id;
                } else if (item.value !== undefined) {
                    value = item.value;
                } else {
                    value = name;
                }
            }
            let result = {
                value,
                label: name,
                name,
                color: item.color
            };
            // result['command'] = () => this.ValueChange(result);
            if (typeof item === 'object') {
                result['data'] = item; // 原值
            }
            return result;
        });
    }
    private formatName(name) {
        if (!this.maxWordCnt) {
            return name;
        } else {
            if (name.length > this.maxWordCnt) {
                return name.substr(0, this.maxWordCnt) + '...';
            } else {
                return name;
            }
        }
    }
}
